function Tc({ html }) {
  return (
    <div
      className="container html-content-detail"
      dangerouslySetInnerHTML={{
        __html: html,
      }}
    ></div>
  );
}
export default Tc;
